<template>
  <div class="m-2 my-3 restaurant-regular shadow" >
    <b-row class="m-0 justify-content-between">
      <b-col cols="7" style="max-height: 180px">
        <div class="mt-2 pb-5 pl-0 pl-md-2 ">
          <h4 class="text-start hover" >{{name.substring(0,25)}}</h4>
          <p class="m-0 text-start hover">{{description}}</p>
          <div @click="openRatingModal()">
          <b-form-rating  readonly class="hover restaurant-rating mr-5" size="md" :no-border="true" variant="warning" v-model="getRating"></b-form-rating>     
          </div>
        </div>
        <div class="restaurant-details linear-warning">
          <b-row class="m-0 justify-content-around mt-2 px-2 ">
            <font-awesome-icon class="mx-2" style="font-size: 20px" :icon="['fas', 'map-marked-alt']"/>
            <p class="mx-2">{{ distance }} km</p>
            <small class="mx-2 d-none d-md-flex">{{ street }}</small>
          </b-row>
        </div>
      </b-col>
      <b-col cols="5" class="p-0">
        <b-row class="m-0 hover justify-content-end">
          <div class="outer-preview">
            <div class="middle-preview">
              <b-row class="m-0 justify-content-center" style="flex-direction: column;">
                <div class="text-center">
                  <b-img :src="getImage(img)" style="max-width:180px;max-height:180px;width: auto;height: auto; border-top-right-radius: 20px !important; border-bottom-right-radius: 20px !important" fluid alt="eatDorado Logo"></b-img>  
                </div>
              </b-row>
            </div>
          </div>
        </b-row>
        
      </b-col>
      
    </b-row>

    <b-modal id="infoModal" size="md" v-model="ratingModal" hide-footer hide-header>
      <div class="bg-white" style="border-radius: 10px; transition: all .5s;">
        <b-row class="m-0 p-3 justify-content-between" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
          <h4 class="ml-2 text-center text-dark" >{{ name }}</h4>
          <font-awesome-icon @click="ratingModal = false" style="font-size: 30px; cursor: pointer" :icon="['fas', 'times']"/>
        </b-row>
        <b-row class="m-0 pb-3 justify-content-center" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
        <h3>Bewertungen</h3>
        </b-row>
        <b-row class="m-0 pb-3 justify-content-center" style="border-top-left-radius: 10px; border-top-right-radius: 10px;" v-if="!ratings">
        aktuell noch keine Bewertungen vorhanden
        </b-row>
        <div class="m-3" v-for="rating in ratings" :key="rating.index">
          {{ rating.text }}
          <b-form-rating  readonly class="hover mb-3 mr-5" size="md" :no-border="true" variant="warning" v-model="rating.rating"></b-form-rating> 
          <b-row class="m-0 justify-content-between">
            <small>{{ rating.sender }}</small>
            <small v-if="rating.date">{{ rating.date | moment('DD.MM.YY HH:MM')}}</small>
          </b-row>
          
          <hr>
        </div>
            
      </div>
    </b-modal>

  </div>
     
</template>

<script>
import coreData from '@/mixins/coreDataMixin'

export default {
  name: 'RestaurantRegularComponent',
  mixins: [coreData],
  props: {
    name: String,
    img: String,
    description: String,
    distance: String,
    rating: Number,
    id: String,
    init: Boolean,
    url: String,
    ratings: Array,
    street: String,
    city: String
  },
  components: {

  },
  data: () => {
    return {
      ratingModal: false
    }
  },
  watch: {
    
  },
  computed: {
    getRating(){
      var rating = 0.0
      if(!this.ratings) return rating
      this.ratings.forEach(el => {
        rating += el.rating
      })

      return rating / this.ratings.length
    }
  },
  mounted(){
    
  },
  methods: {
    openRatingModal(){
      this.ratingModal = true
    }
  }
}
</script>

<style lang="scss" >

  .outer-preview {
    display: table;
    position: relative;
    top: 0;
    left: 0;
    height: 180px;
    width: 100%;
  }

  .middle-preview {
    display: table-cell;
    vertical-align: middle;
  }

  .inner-preview {
    margin-left: auto;
    margin-right: auto;
  }

  .restaurant-regular {
    border-radius: 20px;
    position: relative;
    min-height: 120px;
    max-height: 180px
  }

  .restaurant-details {
    cursor: pointer;
    border-bottom-left-radius: 20px;
    border-top-right-radius: 20px;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 35px;
    position: absolute;
  }
  
  .restaurant-rating {
    bottom: 40px;
    left: 0;
    height: 35px;
    position: absolute;
  }

  .restaurant-distance {
    bottom: 0;
    left: 50%;
    width: 50%;
    height: 35px;
    position: absolute;
  }
</style>
